import { useContext } from "react"

import { SideMenuContext } from "../SideMenuContext"

export const useSideBar = () =>{
    const context = useContext(SideMenuContext);

    if(!context){
        throw new Error ("useSideMenu must be used within a SideMenuProvider")
    }

    return context;
}